import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";
import { motion } from "framer-motion";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import "./Footer.css";

const Footer = () => {
  const [ref, isVisible] = useScrollAnimation(0.1);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.1,
      },
    },
  };

  const columnVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };

  return (
    <footer className="footer-section" ref={ref}>
      <div className="footer-container">
        <motion.div
          className="footer-grid"
          variants={containerVariants}
          initial="hidden"
          animate={isVisible ? "visible" : "hidden"}
        >
          <motion.div className="footer-column" variants={columnVariants}>
            <motion.img
              src="https://customer-assets.emergentagent.com/job_fashion-vite/artifacts/4lfzooeq_1764089903800-removebg-preview.png"
              alt="PSD Designers Logo"
              className="footer-logo"
              whileHover={{ scale: 1.05, rotate: [0, -2, 2, 0] }}
              transition={{ duration: 0.5 }}
            />
            <p className="footer-tagline">Where Stitch Meets Style</p>
          </motion.div>

          <motion.div className="footer-column" variants={columnVariants}>
            <h3 className="footer-column-title">Quick Links</h3>
            <ul className="footer-links">
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <Link to="/services">Services</Link>
              </li>
              <li>
                <Link to="/gallery">Gallery</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </motion.div>

          <motion.div className="footer-column" variants={columnVariants}>
            <h3 className="footer-column-title">Services</h3>
            <ul className="footer-links">
              <li>Custom Tailoring</li>
              <li>Bridal Couture</li>
              <li>Aari Work</li>
              <li>Alterations & Repairs</li>
              <li>All Type of Stitching</li>
            </ul>
          </motion.div>

          <motion.div className="footer-column" variants={columnVariants}>
            <h3 className="footer-column-title">Contact Us</h3>
            <ul className="footer-contact">
              <li>
                <Phone size={18} />
                <a href="tel:+919585693060">+91 95856 93060</a>
              </li>
              <li>
                <MapPin size={18} />
                <span>
                  10A, kaveri street, vembu avanu, Vadavelli, Coimbatore -
                  641041
                </span>
              </li>
              <li>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
                <a
                  href="https://www.instagram.com/senbagampalanisamy561?utm_source=qr&igsh=dmZ3cnlnNmk3eGl2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Instagram
                </a>
              </li>
            </ul>
          </motion.div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
